import { useEffect, useState } from 'react';
import {
  getGenericSubTypes,
  getSubTypeOptions,
  toDropdownOptions,
} from 'helpers';
import { getAllPolicyTypesByProviderId } from 'services';

export const getSubTypeOptionsAsync = async (
  policyProviderId,
  policyTypeName,
) => {
  let subTypes = [];

  if (policyProviderId) {
    const results = await getAllPolicyTypesByProviderId(policyProviderId);
    subTypes = getSubTypeOptions(results.data.Items, policyTypeName);
  }

  if (subTypes.length > 0) {
    return subTypes;
  }

  return toDropdownOptions(getGenericSubTypes(policyTypeName), R.prop('name'));
};

export const usePolicySubTypes = (policyProviderId, policyTypeName) => {
  const [subTypes, setSubTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (policyProviderId && policyTypeName) {
      setLoading(true);
      getSubTypeOptionsAsync(policyProviderId, policyTypeName).then(
        (results) => {
          setSubTypes(results);
          setLoading(false);
        },
      );
    }
  }, [policyProviderId, policyTypeName]);

  return { subTypes, loading };
};
